import { useRoutes } from "react-router";

import { routes } from "./routes";

function AppRouter() {
  return useRoutes(routes);
}

export default AppRouter;
